<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import { _, locale, locales } from "svelte-i18n";
  import { localeLabels } from "../i18n";
  import superagent from "superagent";
  export let user;
  let connection = undefined; //{ id: user.email };
  let edit = false;
  let message = undefined;
  let password = "";
  let credentialsConsent = false;
  let loginMessage = undefined;
  let isOltEnabled = false;

  const oltConfig = useQuery("sessions", () =>
    user.id !== undefined
      ? superagent
          .get("/api/olt")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => response.body)
      : {}
  );

  // Check if olt=true query parameter is present
  $: {
    const urlParams = new URLSearchParams(window.location.search);
    isOltEnabled = urlParams.get("olt") === "true";
  }

  async function connectToOlympiatoppen() {
    try {
      const response = await superagent
        .post("/api/olt")
        .set("Authorization", "Bearer " + user.id)
        .set("Content-Type", "application/json")
        .send({});
      console.log("[INFO] Createt connection");
      connection = { id: user.email };
    } catch (error) {
      console.log("[INFO] Failed to create user");
      if (error.status === 409) {
        edit = true;
        message =
          "Det finnes allerede en bruker med din epost-adresse hos Olympiatoppen. Vennligst oppgi dine opplysninger for å logge inn.";
      } else if (
        error.status === 400 &&
        error.response?.body?.reason === "CLUB_IS_REQUIRED"
      ) {
        message = "Klubb må være angitt for å etablere kobling.";
      } else {
        message = "En feil har oppstått, vennligst prøv igjen senere.";
      }
    }
  }

  async function saveCredentials() {
    try {
      const response = await await superagent
        .put("/api/olt")
        .set("Authorization", "Bearer " + user.id)
        .set("Content-Type", "application/json")
        .send({ email: user.email, password: password });
      console.log("[INFO] Successful login to Olympiatoppen");
      edit = false;
      connection = { id: user.email };
    } catch (error) {
      console.log("[ERROR] Failed to log in to Olympiatoppen");
      loginMessage = "Påloggingen var mislykket, vennligst prøv på nytt";
    }
  }
</script>

{#if $oltConfig.data?.url !== undefined}
  <h1 class="layout__title">Olympiatoppen</h1>
  <div class="card">
    <section class="card__section">
      <a
        href={$oltConfig.data.url}
        style="text-decoration:underline;"
        target="_blank">Åpne Olympiatoppens treningsdagbok</a
      >
    </section>
    <setion class="card__section">
      {#if edit}
        <span class="form-error is-visible">{message}</span>
        <form>
          <fieldset class="form-section">
            <h3>Brukeropplysninger</h3>
            <label for="name" class="input"
              ><span class="input__label" style="color:grey">Epost</span><input
                type="text"
                name="username"
                bind:value={user.email}
                class="input__text"
                id="username"
                readonly="true"
                disabled="disabled"
                style="color:grey; border-color:grey"
              /></label
            >
            <label for="oltPassword" class="input"
              ><span class="input__label">Passord</span><input
                type="password"
                name="password"
                bind:value={password}
                class="input__text"
                id="oldPassword"
                on:input={() => (loginMessage = undefined)}
              /></label
            >
            <label class="checkbox" for="saveCredentials"
              ><input
                type="checkbox"
                class="checkbox__input-hidden"
                id="saveCredentials"
                name="saveCredentials"
                bind:checked={credentialsConsent}
              /><span class="checkbox__input-custom" /><span
                class="checkbox__label"
                >Jeg samtykker til at Friendsta lagrer mine
                påloggingsopplysninger til Olympiatoppens treningsdagbok og
                bruker disse for å synkronisere registreringer.</span
              ></label
            >
            {#if loginMessage}
              <span class="form-error is-visible">{loginMessage}</span>
            {/if}
          </fieldset>

          <div class="layout-buttons layout-buttons--left-right">
            <button
              on:click={() => (edit = false)}
              type="button"
              class="button-text button-text--cancel"
              >{$_("generic.buttons.cancel")}</button
            >
            <button
              on:click={saveCredentials}
              type="button"
              disabled={password.trim().length < 8 || !credentialsConsent}
              class="button button--icon button--icon-login {password.trim()
                .length < 8 || !credentialsConsent
                ? 'button--disabled'
                : ''}">Etabler kobling</button
            >
          </div>
        </form>
      {:else if connection !== undefined}
        Tilknyttet med epost <i>{connection.id}</i>
      {:else}
        <a
          on:click|preventDefault={isOltEnabled
            ? connectToOlympiatoppen
            : () => {}}
          class="button {!isOltEnabled ? 'button--disabled' : ''}"
          disabled={!isOltEnabled}
          href="/minside/endre-informasjon"
          style={!isOltEnabled ? "pointer-events: none;" : ""}
          >Etabler kobling</a
        >
        {#if message}
          <span class="form-error is-visible">{message}</span>
        {/if}
      {/if}
      <div style="display:{isOltEnabled ? '' : 'none'}">
        Config:
        <pre style="font-size:8pt">{JSON.stringify(
            $oltConfig.data,
            null,
            2
          )}</pre>
      </div>
    </setion>
  </div>
{/if}
